import { useCallback } from "react";
import { useNavigate } from "react-router";
import { Button, type ButtonPropsType } from "@core/components/ui/Button";
import { useFetchNcfzLogout } from "@features/auth/hooks/mutations/useNcfzLogin";

export default function NcfzLogoutLink({ className, variant, size }: { className?: string; variant: ButtonPropsType["variant"]; size: ButtonPropsType["size"] }) {
  const { mutate: fetchNcfzLogout } = useFetchNcfzLogout();
  const navigate = useNavigate();

  const clickHandler = useCallback(() => {
    // NCFZ Logout
    fetchNcfzLogout();

    // 메인으로 이동
    navigate("/");
  }, [fetchNcfzLogout, navigate]);

  return (
    <Button {...{ className, variant, size }} onClick={clickHandler}>
      로그아웃
    </Button>
  );
}
